import { useEffect, useState } from 'react'
import { useAuth } from 'lib/auth'
import { useCreateSubscriptionPaymentSession } from 'lib/graphql/mutations/create-subscription-payment-session'
import { MY_PGA_COM_HOST } from 'env'
import { amplitudeEvent } from 'lib/amplitude'
import useQueryString from 'lib/hooks/use-query-string'
import { useSnackbar, useSnackbarError } from 'lib/snackbar'
import { useHistory } from 'react-router-dom'

export const useUpgradeFlow = pageName => {
  const { user } = useAuth()
  const queryString = useQueryString()
  const [showSuccessModal, setShowSuccessModal] = useState(false)
  const history = useHistory()
  const { enqueueSnackbar } = useSnackbar()
  const snackbarError = useSnackbarError(enqueueSnackbar)

  const hasPaidTier = user?.coach?.hasPaidTierSubscription

  useEffect(() => {
    if (!hasPaidTier) {
      amplitudeEvent('coach-plus-upgrade-prompt-shown', {
        path: window.location.pathname,
        page: pageName,
      })
    }
  }, [hasPaidTier, pageName])

  useEffect(() => {
    if (queryString.subscription_success === 'true') {
      amplitudeEvent('coach-plus-upgrade-success', {
        path: window.location.pathname,
        page: pageName,
      })
      setShowSuccessModal(true)
    }
  }, [queryString.subscription_success, pageName])

  const successUrl = `${MY_PGA_COM_HOST}${window.location.pathname}?subscription_success=true`
  const [
    callCreateSubscriptionPaymentSession,
    { loading: upgradeLoading },
  ] = useCreateSubscriptionPaymentSession()

  const handleUpgradeClick = async () => {
    try {
      amplitudeEvent('coach-plus-upgrade-clicked', {
        path: window.location.pathname,
        page: pageName,
      })
      const { data } = await callCreateSubscriptionPaymentSession({
        variables: { successUrl },
      })
      const {
        url,
        success,
        message,
      } = data?.createPgaCoachSubscriptionPaymentSession
      if (!success) {
        return snackbarError(message)
      }
      if (success && url) {
        window.location.href = url
      }
    } catch (e) {
      snackbarError(e?.message)
    }
  }

  const handleDismiss = () => {
    setShowSuccessModal(false)

    // Remove the subscription_success query parameter from URL
    const url = new URL(window.location.href)
    url.searchParams.delete('subscription_success')
    history.replace(url.pathname + url.search)
  }

  return {
    hasPaidTier,
    showSuccessModal,
    upgradeLoading,
    handleUpgradeClick,
    handleDismiss,
  }
}
